



















import { Communication, PartnerEmployerList } from "@/employer/types";
import { Component, Vue, Prop } from "../../../shared/vuepack";
import moment from "moment";
import AddCommunication from "@/employer/components/communications/AddCommunication.vue";
import { CommunicationPortal } from "@/shared/types";

@Component({
  components: {AddCommunication}
})
export default class CommunicationRow extends Vue {
  moment = moment;

  @Prop()
  communication: Communication;

  @Prop()
  partnerId: number;

  @Prop()
  portal: CommunicationPortal;

  @Prop()
  refreshData: () => void;

  isOpen = false;

  getEndDate (): string {
    if (!this.communication.endDate) {
      return "";
    }
    else return moment(this.communication.endDate).format("MMM D, YYYY");
  }

  get cssText () {
    return this.isActive ? "active" : "inactive";
  }

  clicked () {
    this.isOpen = !this.isOpen;
  }

  get isActive () {
    return this.moment(this.communication.startDate) <= this.moment.utc()
        && (!this.communication.endDate || this.moment.utc() <= this.moment(this.communication.endDate));
  }

  cancel (): void {
    this.isOpen = false;
    this.refreshData();
  }
}
